import type {
  PlatformSettings,
  PlatformSettingsValues,
} from '@/services/business/settings';
import { cloneJson } from '@/utils/cloneJson';

const initialSettings: PlatformSettings = {
  general: {
    siteTitle: 'AI 网关管理平台',
    shortTitle: 'AI 网关',
    logoDataUrl: null,
    browserTitle: 'AI 网关管理平台',
    copyright: 'Copyright 2026 AI 网关管理平台',
  },
  security: {
    loginAccess: 'all',
    maintenanceEnabled: false,
    maintenanceMessage: '系统维护中，请稍后再试。',
  },
  notifications: {
    announcementsEnabled: true,
    inboxEnabled: true,
  },
  version: 1,
};

let settings: PlatformSettings = cloneJson(initialSettings);

export function getSettingsState() {
  return cloneJson(settings);
}

export function updateSettingsState(values: PlatformSettingsValues) {
  settings = cloneJson({
    ...values,
    version: settings.version + 1,
  });
  return getSettingsState();
}

export function resetSettingsState() {
  settings = cloneJson(initialSettings);
}
